// Mock data for GMM Intel platform
import AartiIndustriesLogo from '../images/logos/Aarti_Industries.jpeg';
import AlkylAminesLogo from '../images/logos/Alkyl_Amines.svg';
import APIndustrialInfrastructureLogo from '../images/logos/AP_Industrial_Infrastructure.svg';
import AurobindoPharmaLogo from '../images/logos/Aurobindo_Pharma.png';
import ChineseGLImportersLogo from '../images/logos/Chinese_GL_Importers.svg';
import CPCBLogo from '../images/logos/CPCB.svg';
import CPWDIITHyderabadLogo from '../images/logos/CPWD_IIT_Hyderabad.svg';
import DeDietrichIndiaLogo from '../images/logos/De_Dietrich_India.svg';
import DeepakNitriteLogo from '../images/logos/Deepak_Nitrite.jpeg';
import DivisLaboratoriesLogo from '../images/logos/Divis_Laboratories.svg';
import DrReddysLogo from '../images/logos/Dr_Reddys.png';
import GranulesIndiaLogo from '../images/logos/Granules_India.svg';
import HLEGlascoatLogo from '../images/logos/HLE_glascoat.png';
import HLLLifecareLogo from '../images/logos/HLL_Lifecare.svg';
import IndianOilCorporationLogo from '../images/logos/Indian_Oil_Corporation.svg';
import LaurusLabsLogo from '../images/logos/Laurus_Labs.svg';
import MinistryOfChemicalsLogo from '../images/logos/Ministry_of_Chemicals.svg';
import NeulandLaboratoriesLogo from '../images/logos/Neuland_Laboratories.svg';
import PIIndustriesLogo from '../images/logos/PI_Industries.svg';
import RallisIndiaLogo from '../images/logos/Rallis_India.svg';
import SachinIndustriesLogo from '../images/logos/Sachin_Industries.svg';
import StandardGlassLiningLogo from '../images/logos/Standard_Glass_Lining.svg';
import UPLLogo from '../images/logos/UPL.jpeg';

export const keyCompetitors = [
  { id: 1, name: 'HLE Glascoat', logo: HLEGlascoatLogo, color: '#0B5CAD' },
  { id: 2, name: 'Standard Glass Lining Technology', logo: StandardGlassLiningLogo, color: '#1F3C88' },
  { id: 3, name: 'Sachin Industries', logo: SachinIndustriesLogo, color: '#2E7D32' },
  { id: 4, name: 'De Dietrich India (exited, monitoring)', logo: DeDietrichIndiaLogo, color: '#7B1FA2' },
  { id: 5, name: 'Chinese GL Importers (generic)', logo: ChineseGLImportersLogo, color: '#455A64' },
];

export const keyCustomers = [
  { id: 1, name: "Divi's Laboratories", logo: DivisLaboratoriesLogo, color: '#1565C0' },
  { id: 2, name: "Dr. Reddy's", logo: DrReddysLogo, color: '#00695C' },
  { id: 3, name: 'Aurobindo Pharma', logo: AurobindoPharmaLogo, color: '#0277BD' },
  { id: 4, name: 'Laurus Labs', logo: LaurusLabsLogo, color: '#512DA8' },
  { id: 5, name: 'Granules India', logo: GranulesIndiaLogo, color: '#3949AB' },
  { id: 6, name: 'Neuland Laboratories', logo: NeulandLaboratoriesLogo, color: '#00838F' },
  { id: 7, name: 'Aarti Industries', logo: AartiIndustriesLogo, color: '#EF6C00' },
  { id: 8, name: 'Deepak Nitrite', logo: DeepakNitriteLogo, color: '#D84315' },
  { id: 9, name: 'PI Industries', logo: PIIndustriesLogo, color: '#43A047' },
  { id: 10, name: 'Alkyl Amines', logo: AlkylAminesLogo, color: '#6D4C41' },
  { id: 11, name: 'UPL', logo: UPLLogo, color: '#2E7D32' },
  { id: 12, name: 'Rallis India', logo: RallisIndiaLogo, color: '#558B2F' },
];

export const focusAreaOptions = ['All', 'Capex', 'Competitive', 'Cluster', 'Regulatory'];

export const latestInsights = [
  {
    id: 1,
    insightCompany: "Divi's Laboratories",
    insightDate: '28 Apr 2026',
    title: "Divi's Laboratories · 28 Apr 2026",
    description: 'Capex Signal: ₹1,200Cr Vizag Unit III expansion board-approved',
    drawerBody:
      'Board-approved capex earmarks ₹1,200Cr for Vizag Unit III with a phased reactor block focused on CRAMS shipments to European pharma. Procurement RFQs are likely to concentrate on glass-lined vessels in Q2 FY2027.',
    bgColor: '#E8F4F8',
    focusCategory: 'Capex',
  },
  {
    id: 2,
    insightCompany: 'HLE Glascoat',
    insightDate: '25 Apr 2026',
    title: 'HLE Glascoat, Standard Glass & 2 more · 25 Apr 2026',
    description: 'What capacity additions are competitors planning in H1 FY27?',
    drawerBody:
      'Competitors are scaling furnace capacity ahead of PLC-driven replacement cycles and PLI disbursement deadlines. Capacity additions at Anand signal aggressive pricing tension in vessels under €8K equivalent.',
    bgColor: '#E8F4F8',
    focusCategory: 'Competitive',
  },
  {
    id: 3,
    insightCompany: 'Aarti Industries',
    insightDate: '20 Apr 2026',
    title: 'Aarti Industries, Deepak Nitrite · 20 Apr 2026',
    description: 'Which Gujarat cluster customers have unactioned capex approvals?',
    drawerBody:
      'Several Gujarat cluster accounts show board-approved capex that has not converted to reactor RFQs yet. Consolidated watchlist prioritizes Dahej SEZ and Vadodara expansion corridors tied to benzene-chain chemistry.',
    bgColor: '#E8F4F8',
    focusCategory: 'Cluster',
  },
  {
    id: 4,
    insightCompany: 'CPCB',
    insightDate: '18 Apr 2026',
    title: 'CPCB · 18 Apr 2026',
    description: 'New effluent norms force reactor lining upgrades — how large is the replacement demand?',
    drawerBody:
      'CPCB’s deadline compresses retrofit windows across 180+ notified plants and reframes sizing for replacement reactors. Procurement teams typically stage lining upgrades alongside brownfield capex approvals.',
    bgColor: '#E8F4F8',
    focusCategory: 'Regulatory',
  },
];

export const keyUpdates = [
  {
    id: 1,
    image: '🏭',
    title: 'Aarti Industries announces ₹800Cr Dahej SEZ capex for specialty chemicals expansion',
    source: 'Aarti Industries',
    date: '27 Apr 2026',
    bgColor: '#1E3A5F',
    articleBody:
      'Aarti Industries issued a regulatory filing outlining board approval for ₹800Cr specialty chemicals capex centred on Dahej SEZ.\n\nThe programme targets benzene-derivative capacity with phased reactor procurements slated from Q1 FY27. Management guided that equipment RFQs—including glass-lined process trains—would run in waves through FY28 with visibility on six large reactor trains in the initial tranche.',
  },
  {
    id: 2,
    image: '🔥',
    title: 'HLE Glascoat commissions new furnace line, cuts delivery lead time to 10 weeks',
    source: 'Business Standard',
    date: '25 Apr 2026',
    bgColor: '#1E3A5F',
    articleBody:
      'HLE Glascoat completed commissioning of an additional furnace line at its Anand campus, materially expanding monthly EU throughput.\n\nAnalyst commentary highlights shorter delivery cycles for standardized glass-lined reactors, especially in vessels below mid-size thresholds. Procurement teams cited competitive tension from Chinese import alternatives tempered by CPCB timelines that favour domestically serviced lining retrofits.',
  },
];

export const favouriteDashboards = [
  {
    id: 1,
    title: 'Competitive Edge Dashboard',
    workspace: 'Workspace: Strategy',
    workspaceId: 'strategy',
  },
  {
    id: 2,
    title: 'Customer Capex Tracker',
    workspace: 'Workspace: Sales',
    workspaceId: 'sales',
  },
];

/** Mock clipboard / open-in-tab URLs */
export const MOCK_INTEL_FEED_URL =
  'https://intel.example.gmm-pfaudler.com/market/competitive/mock-feed?view=share';

/** Timeline row detail text (paired with dashboard timeline built from news) */
export const timelineDetailByNewsId = {
  1: "Board resolution authorizes ₹1,200Cr phased reactor procurements targeting CRAMS throughput for Vizag Unit III.\nManagement confirmed alignment with FY28 completion targets and signaled competitive RFQs for standardized glass-lined trains.",
  2: 'Furnace expansion lifts measured EU/month capacity materially while shortening delivery SLA for Anand-built vessels competing on small-batch pharma orders.',
  3: 'PLI disbursement wave obligates mandated capacity ramps within regulatory windows across Gujarat and Andhra clusters.',
  4: 'FY27 capex focus on benzene-chain chemistry aligns with reactor clusters previously flagged in Gujarat monitoring dashboards.',
  5: 'CPCB timelines compress remediation windows across 180+ pharma plants listed in statutory notices published Q1 FY2026.',
  6: 'GEM e-tender for IOCL Vadodara R&D cluster lists multi-size glass-lined reactors with QSTP cladding; technical bid closes 18 May 2026 with phased delivery FY27.',
  7: 'HLL Lifecare bulk tender specifies stainless transition skids paired with standardized GL reactors; MSME consortium bidding window noted for Gujarat-based fabricators.',
  8: 'AP State nodal PSU seeks OEM plus 10-year service contract on effluent-upgrade trains; CPCB-aligned lining specs flagged as mandatory eligibility.',
  9: 'CPWD IIT-Hyderabad central lab modernization includes pilot-scale GL trains; two-bid system with domestic value-add preference for Class-I suppliers.',
};

export const favouriteSearches = [
  { id: 1, title: 'HLE Glascoat capacity expansion' },
  { id: 2, title: 'PLI pharma disbursements Gujarat' },
  { id: 3, title: 'Dahej cluster new plants' },
  { id: 4, title: 'Government tenders glass-lined reactors' },
];

// Newsfeed mock data
export const newsItems = [
  {
    id: 1,
    company: {
      name: "Divi's Laboratories",
      logo: DivisLaboratoriesLogo,
      color: '#1565C0',
    },
    source: 'BSE Filing',
    date: '28 Apr 2026',
    publishedDate: '28 Apr 2026',
    title: "Divi's Board approves ₹1,200Cr capex for Vizag Unit III expansion",
    description:
      'Board resolution passed for new reactor block at Visakhapatnam facility targeting CRAMS capacity for European pharma clients.',
    image: '📄',
    keyHighlights: [
      {
        id: 1,
        text: 'New reactor block to add 40 glass-lined reactor vessels at Vizag',
        checked: true,
      },
      {
        id: 2,
        text: 'Construction timeline 18 months, completion Q3 FY2028',
        checked: false,
      },
      {
        id: 3,
        text: 'Targets CRAMS capacity expansion for European pharma clients',
        checked: false,
      },
    ],
  },
  {
    id: 2,
    company: {
      name: 'HLE Glascoat',
      logo: HLEGlascoatLogo,
      color: '#0B5CAD',
    },
    source: 'Business Standard',
    date: '25 Apr 2026',
    publishedDate: '25 Apr 2026',
    title: 'HLE Glascoat commissions new furnace line at Anand facility',
    description:
      'Capacity increases from 55 to 80 EU/month. Targeting small and mid-vessel segment aggressively on price.',
    image: '🏗️',
    keyHighlights: [
      {
        id: 1,
        text: 'Capacity increases from 55 to 80 EU/month at Anand plant',
        checked: true,
      },
      {
        id: 2,
        text: 'Targeting small vessel segment with pricing 12-15% below GMM list price',
        checked: false,
      },
      {
        id: 3,
        text: 'Delivery lead time reduced to 10 weeks vs industry average of 14 weeks',
        checked: false,
      },
    ],
  },
  {
    id: 3,
    company: {
      name: 'Ministry of Chemicals',
      logo: MinistryOfChemicalsLogo,
      color: '#37474F',
    },
    source: 'Gazette Notification',
    date: '22 Apr 2026',
    publishedDate: '22 Apr 2026',
    title: 'PLI Phase 2 disbursements approved for 34 API manufacturers',
    description:
      '₹3,400Cr disbursed. 12 beneficiaries in Gujarat, 14 in Andhra Pradesh. Triggers mandatory capacity expansion within 24 months.',
    image: '📢',
    keyHighlights: [
      {
        id: 1,
        text: '₹3,400Cr disbursed across 34 companies under PLI Phase 2',
        checked: true,
      },
      {
        id: 2,
        text: '12 beneficiaries in Gujarat, 14 in Andhra Pradesh',
        checked: false,
      },
      {
        id: 3,
        text: 'Scheme terms mandate capacity expansion within 24 months of disbursement',
        checked: false,
      },
    ],
  },
  {
    id: 4,
    company: {
      name: 'Aarti Industries',
      logo: AartiIndustriesLogo,
      color: '#EF6C00',
    },
    source: 'Earnings Call',
    date: '20 Apr 2026',
    publishedDate: '20 Apr 2026',
    title: 'Aarti Industries CFO confirms ₹800Cr Dahej SEZ capex in FY27',
    description:
      'Specialty chemical expansion targets benzene derivatives capacity. New plant at Dahej SEZ with estimated 6 new process reactor lines.',
    image: '📞',
    keyHighlights: [
      {
        id: 1,
        text: 'New plant at Dahej SEZ targeting benzene derivatives capacity',
        checked: true,
      },
      {
        id: 2,
        text: 'Estimated 6 new process reactor lines, RFQ process begins Q1 FY27',
        checked: false,
      },
      {
        id: 3,
        text: 'Management guided equipment procurement to start Q2 FY27',
        checked: false,
      },
    ],
  },
  {
    id: 5,
    company: {
      name: 'CPCB',
      logo: CPCBLogo,
      color: '#455A64',
    },
    source: 'Regulatory Notice',
    date: '18 Apr 2026',
    publishedDate: '18 Apr 2026',
    title: 'CPCB tightens effluent norms — reactor lining upgrades mandatory by Oct 2026',
    description:
      'Affects 180+ pharma plants in notified zones. Pre-2018 glass-lined equipment specs require replacement. Creates 12-18 month demand surge.',
    image: '⚠️',
    keyHighlights: [
      {
        id: 1,
        text: 'Affects 180+ pharma manufacturing plants in notified industrial zones',
        checked: true,
      },
      {
        id: 2,
        text: 'Pre-2018 glass-lined equipment lining specs non-compliant under new norms',
        checked: false,
      },
      {
        id: 3,
        text: 'Oct 2026 deadline creates concentrated replacement equipment demand',
        checked: false,
      },
    ],
  },
  {
    id: 6,
    company: {
      name: 'Indian Oil Corporation Ltd.',
      logo: IndianOilCorporationLogo,
      color: '#1B5E20',
    },
    source: 'Government Tender',
    date: '02 May 2026',
    publishedDate: '02 May 2026',
    title:
      'GEM/2026/IOCL‑VDS‑GLR‑044: procurement of jacketed glass‑lined reactors (8–16 kL) — Vadodara R&D campus',
    description:
      'Two‑stage GEM tender; earnest money ₹22L; pre‑bid conference 06 May 2026. Covers supply, FAT at OEM, inland transportation, supervised erection hooks, and 36‑month AMC option.',
    image: '📋',
    keyHighlights: [
      {
        id: 1,
        text: 'Technical bid closes 18 May 2026; commercials open post QSTP conformity check',
        checked: true,
      },
      {
        id: 2,
        text: 'DIN-compliant agitator shafts; ATEX‑rated drives for solvents bay',
        checked: false,
      },
      {
        id: 3,
        text: 'Liquidated damages capped at 0.5%/week; phased delivery FY27 Q1–Q3',
        checked: false,
      },
    ],
  },
  {
    id: 7,
    company: {
      name: 'HLL Lifecare Ltd.',
      logo: HLLLifecareLogo,
      color: '#0277BD',
    },
    source: 'Government Tender',
    date: '30 Apr 2026',
    publishedDate: '30 Apr 2026',
    title:
      'CORP‑PHAR‑TDR/2026/119: turnkey glass‑lined reactors and transition skids for bulk API corridor — Kerala',
    description:
      'CPSE procurement under delegated powers; aligns with phased API cluster upgrades. Separate lots for reactors, skid integration, IQ/OQ protocols, and three‑year OEM support.',
    image: '📋',
    keyHighlights: [
      {
        id: 1,
        text: 'MSME bidder relaxation on prior turnover with bank guarantee slab',
        checked: true,
      },
      {
        id: 2,
        text: 'Skid scope includes Hastelloy overlays on critical weldments',
        checked: false,
      },
      {
        id: 3,
        text: 'Site acceptance within 180 days of LOI; penal interest on delays',
        checked: false,
      },
    ],
  },
  {
    id: 8,
    company: {
      name: 'AP Industrial Infrastructure Corp.',
      logo: APIndustrialInfrastructureLogo,
      color: '#5D4037',
    },
    source: 'Government Tender',
    date: '27 Apr 2026',
    publishedDate: '27 Apr 2026',
    title:
      'APSIPC/ENV‑26/‑GL‑708: CPCB‑aligned reactor lining retrofit package — effluent tertiary treatment PPP',
    description:
      'State PSU invites bids for reactor trains supporting tertiary treatment across three notified pharma parks. Tender ties performance guarantees to CPCB effluent KPIs.',
    image: '📋',
    keyHighlights: [
      {
        id: 1,
        text: 'Mandatory OEM workshop visit + lining thickness mapping report',
        checked: true,
      },
      {
        id: 2,
        text: 'Ten‑year unified service SLA including annual spark testing',
        checked: false,
      },
      {
        id: 3,
        text: 'JV allowed with disclosed foreign technology partner capped at 26%',
        checked: false,
      },
    ],
  },
  {
    id: 9,
    company: {
      name: 'CPWD — IIT Hyderabad',
      logo: CPWDIITHyderabadLogo,
      color: '#4A148C',
    },
    source: 'Government Tender',
    date: '26 Apr 2026',
    publishedDate: '26 Apr 2026',
    title:
      'GEM/CPWD‑IITH/2026/CH‑GL‑12: pilot‑scale multipurpose GL reactor battery for central chemical engineering lab',
    description:
      'Domestic‑value preference applicable; IIT technical evaluation committee chaired by dean (R&D). Includes digital twin commissioning package optional Lot‑B.',
    image: '📋',
    keyHighlights: [
      {
        id: 1,
        text: 'Two‑bid system with price bid opening post technical shortlist ≤5 OEMs',
        checked: true,
      },
      {
        id: 2,
        text: 'Class‑I supplier accreditation or equivalent IIT‑approved certification',
        checked: false,
      },
      {
        id: 3,
        text: 'Delivery IIT Hyderabad campus; hoist path survey supplied in RFP appendix',
        checked: false,
      },
    ],
  },
];

export const filterCategories = {
  companies: [
    { id: 1, name: 'Key Competitors', icon: '🔵', count: 5 },
    { id: 2, name: 'Customers', icon: '🟣', count: 12 },
    { id: 3, name: 'Suppliers', icon: '🔴', count: 0 },
    { id: 4, name: 'Partners', icon: '🟢', count: 0 },
  ],
  topics: [
    { id: 1, name: 'Capex Announcements', icon: '🔵', count: 0 },
    { id: 2, name: 'Regulatory Updates', icon: '🟢', count: 0 },
    { id: 3, name: 'Leadership Moves', icon: '🟣', count: 0 },
    { id: 4, name: 'Business Events', icon: '🟠', count: 0 },
  ],
  sourcesContent: [
    { id: 1, name: 'BSE Filing', icon: '🟠', count: 0 },
    { id: 2, name: 'Earnings Call', icon: '🟣', count: 0 },
    { id: 3, name: 'Govt Notification', icon: '🔵', count: 0 },
    { id: 4, name: 'News Article', icon: '🟢', count: 0 },
    { id: 5, name: 'Regulatory Notice', icon: '🟠', count: 0 },
    { id: 6, name: 'Government Tender', icon: '📑', count: 0 },
  ],
  locations: [
    { id: 1, name: 'Gujarat', icon: '🟣', count: 0 },
    { id: 2, name: 'Hyderabad', icon: '🔵', count: 0 },
    { id: 3, name: 'Pan-India', icon: '🟠', count: 0 },
    { id: 4, name: 'Andhra Pradesh', icon: '🟢', count: 0 },
  ],
};

/** Competitive Edge Dashboard */
export const dashboardMyWorkspace = [
  { id: 'strategy', label: 'Strategy' },
  { id: 'marketing', label: 'Marketing' },
  { id: 'product', label: 'Product' },
  { id: 'sales', label: 'Sales' },
  { id: 'profiles', label: 'Company Profiles' },
  { id: 'managed', label: 'Managed Services' },
];

export const dashboardSharedWorkspace = [
  { id: 'benchmark', label: 'Competitor Benchmark' },
  { id: 'digital', label: 'Digital Spend Analysis' },
  { id: 'hubspot', label: 'HubSpot' },
  { id: 'pricing', label: 'Product Pricing' },
];

export const dashboardShortcutPills = [
  'Competitor Analysis',
  'New Products / Enhancements',
  'Customers by Location',
  'Lose (Win-Loss) Reasons',
  'More',
];

export const dashboardCompetitorActivity = [
  `HLE Glascoat commissioned a new furnace line at Anand, lifting capacity from 55 to 80 EU/month and reducing delivery lead time to ~10 weeks — tightening competition in small/mid glass-lined vessels.`,
  `Standard Glass Lining Technology and Sachin Industries remain active in western India; monitor tender participation and list-price moves versus imported Chinese GL alternatives.`,
  `De Dietrich India is exited but worth tracking for residual channel inventory and replacement cycles that may shift demand across domestic suppliers.`,
  `Chinese GL importers continue to pressure pricing on generic vessels; combine win-loss notes with CPCB-driven upgrade timelines to size replacement pull-through.`,
];

export const dashboardWordCloudTerms = [
  { term: 'Glass-Lined Reactors', weight: 5 },
  { term: 'PHARMA CAPEX', weight: 5 },
  { term: 'GUJARAT CLUSTER', weight: 4 },
  { term: 'CPCB NORMS', weight: 4 },
  { term: 'PLI DISBURSEMENTS', weight: 4 },
  { term: 'COMPETITIVE INTELLIGENCE', weight: 3 },
  { term: 'CRAMS', weight: 3 },
  { term: 'REPLACEMENT DEMAND', weight: 3 },
  { term: 'MARKET INTELLIGENCE', weight: 3 },
  { term: 'SPECIALTY CHEMICALS', weight: 2 },
  { term: 'API MANUFACTURING', weight: 2 },
  { term: 'WIN-LOSS', weight: 2 },
];

/** Dashboard chart strip — mock aggregates */
export const dashboardSignalsByMonth = [
  { month: 'Nov', value: 14 },
  { month: 'Dec', value: 19 },
  { month: 'Jan', value: 22 },
  { month: 'Feb', value: 17 },
  { month: 'Mar', value: 26 },
  { month: 'Apr', value: 24 },
];

export const dashboardWinLossMix = [
  { label: 'Won', value: 38, color: '#16a34a' },
  { label: 'Lost', value: 27, color: '#dc2626' },
  { label: 'No decision', value: 21, color: '#94a3b8' },
  { label: 'In pipeline', value: 14, color: '#2563eb' },
];

export const dashboardShareOfVoice = [
  { label: 'GMM Pfaudler', value: 100, color: '#1d4ed8' },
  { label: 'HLE Glascoat', value: 72, color: '#7c3aed' },
  { label: 'Std. Glass Lining', value: 58, color: '#c026d3' },
  { label: 'Chinese GL imports', value: 64, color: '#ea580c' },
  { label: 'Sachin Industries', value: 41, color: '#0d9488' },
];
